/**
 * Human-friendly names for mask overlays in the pathology workspace.
 *
 * Overlay series identifiers (`E25417-HE__tissue_segmentation`, …) are
 * informatician noise for annotators, so the UI shows the overlay's domain
 * ("Tissue segmentation") instead. Raw identifiers stay available as tooltips.
 */

/** Turns `tissue_segmentation` / `cell-segmentation` into `Tissue segmentation`. */
export function humanizeDomain(domain: string): string {
  const words = domain
    .split(/[_\-\s]+/)
    .map((w) => w.trim())
    .filter(Boolean)
  if (words.length === 0) return ""
  const sentence = words.join(" ").toLowerCase()
  return sentence.charAt(0).toUpperCase() + sentence.slice(1)
}

/**
 * Display name for a mask / overlay series: its domain when declared,
 * otherwise a generic "Overlay". Never the series identifier.
 */
export function overlayDisplayName(source: { domain?: string | null }): string {
  const domain = source.domain?.trim()
  return domain ? humanizeDomain(domain) : "Overlay"
}
